import * as React from "react"
import {Box} from "@mui/material";
import {ButtonLoadingSeeker} from "@ui-seeker/core";

import {useRepricingCrudDryChecker, useRepricingFormAction} from "../@hooks";
import {isLoadingRepricingFormChecker} from "../../@signals";


export default function RepricingCrudFormSubmitBlock() {
	const { isLoading, isValid, handleSubmit } = useRepricingFormAction()
	const { handlePreview } = useRepricingCrudDryChecker()

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
		<ButtonLoadingSeeker
			variant="outlined"
			loading={isLoading}
			disabled={isLoadingRepricingFormChecker.value || !isValid}
			onClick={handleSubmit}
		>
			Save rule
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			loading={isLoadingRepricingFormChecker.value}
			disabled={isLoading || !isValid}
			onClick={handlePreview}
		>
			Preview rule
		</ButtonLoadingSeeker>
	</Box>
}